<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { supportEmail } from '@/configs';

const props = defineProps<{ full: boolean; limit: number | null }>();
const { t } = useI18n();
const visible = computed(() => props.full && props.limit !== null);
</script>

<template>
    <p
        v-if="visible"
        class="border-t border-amber-200 bg-amber-50 p-3.5 text-xs font-medium text-amber-800"
        role="status"
    >
        {{ t('whatsappMeta.quota.fullNotice', { limit }) }}
        <a class="text-primary underline" :href="`mailto:${supportEmail}`">{{ supportEmail }}</a
        >.
    </p>
</template>
